import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';

@Component({
  selector: 'app-error-pago',
  templateUrl: './error-pago.component.html',
  styleUrls: ['./error-pago.component.scss']
})
export class ErrorPagoComponent implements OnInit {

  public loadingButton = false;

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private productoVM: vmProductosService,
    private carroService: CarroComprasService
  ) { }

  ngOnInit() {
    const dataPaso3 = this.localStorageService.getPaso3();

    if (!dataPaso3) {
      this.router.navigate(['/']);
    }
   }

  public intentarNuevamente() {
    this.loadingButton = true;
    this.goPay();
  }

  private async goPay(): Promise<void> {
    try {
      const urlPago = await this.productoVM.obtenerUrlPago();
      window.location.href = urlPago.urlPago;
    } catch (error) {
      console.error('error', error);
      this.loadingButton = false;
    }
  }
}
